export function isNil(x) { return x == null; }
